import { useFeatureFlags } from 'Utilities/hooks';

import { useServiceFeeEligibility } from './useServiceFeeEligibility';

type UseServiceFeeEnabledProps = {
  dpEnquiryId?: number;
};

type UseServiceFeeEnabledReturn = {
  isServiceFeeEligibilityLoading: boolean;
  isServiceFeeEnabled: boolean;
  showServiceFee: boolean;
};

export const useServiceFeeEnabled = ({
  dpEnquiryId,
}: UseServiceFeeEnabledProps): UseServiceFeeEnabledReturn => {
  const { showServiceFee } = useFeatureFlags();

  const { isEligibilityLoading, isEnquiryEligibleForServiceFee } = useServiceFeeEligibility({
    dpEnquiryId,
    enabled: Boolean(showServiceFee),
  });

  return {
    isServiceFeeEligibilityLoading: Boolean(showServiceFee) && isEligibilityLoading,
    isServiceFeeEnabled: Boolean(showServiceFee) && isEnquiryEligibleForServiceFee,
    showServiceFee: Boolean(showServiceFee),
  };
};
